/* global google */
import React from 'react';
import PropTypes from 'prop-types';

import {withMap} from './utils';

class Polyline extends React.Component {
  static displayName = 'Polyline';

  static propTypes = {
    map: PropTypes.object.isRequired,
    path: PropTypes.arrayOf(PropTypes.shape({
      lat: PropTypes.number.isRequired,
      lng: PropTypes.number.isRequired,
    })),
    icons: PropTypes.arrayOf(PropTypes.object),
    strokeColor: PropTypes.string,
    strokeOpacity: PropTypes.number,
    strokeWeight: PropTypes.number,
  };

  componentDidMount() {
    this._polyline = new google.maps.Polyline({map: this.props.map});
    this._updateOptions();
  }

  componentDidUpdate() {
    this._updateOptions();
  }

  componentWillUnmount() {
    this._polyline.setMap(null);
  }

  _updateOptions = () => {
    this._polyline.setOptions({
      icons: this.props.icons,
      path: this.props.path,
      strokeColor: this.props.strokeColor,
      strokeOpacity: this.props.strokeOpacity,
      strokeWeight: this.props.strokeWeight,
    });
  };

  render() {
    return null;
  }
}

export default withMap(Polyline);



// WEBPACK FOOTER //
// ./src/common/components/BetterMap/Polyline.js